import * as ast from '../../generated/ast.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateNodeInputs(node, nodeFields, pifFileSummary, accept) {
    const { idField, nodeTypeField, nodeInputsField } = nodeFields;
    // nodeInput is only for action nodes
    if (nodeTypeField?.nodeType?.value !== 'A')
        return;
    if (!nodeInputsField || ast.isEmptyField(nodeInputsField.nodeInput))
        return;
    const nodeInputItems = nodeInputsField.nodeInput.value.split(',');
    // The inputVariable should not be repeated in items, so we need to keep track
    const inputVariableMap = {};
    nodeInputItems.forEach((nodeInputItem) => {
        // There are two possible formats for a node input item
        // inputVariable:nodeNumber or inputVariable:nodeNumber*payloadVariableName
        let hasFormattingErrors = false;
        const indexOfColon = nodeInputItem.indexOf(':');
        const lastIndexOfColon = nodeInputItem.lastIndexOf(':');
        const indexOfStar = nodeInputItem.indexOf('*');
        const lastIndexOfStar = nodeInputItem.lastIndexOf('*');
        // Also (~, | and =) characters are not allowed
        const indexOfTilde = nodeInputItem.indexOf('~');
        const indexOfPipe = nodeInputItem.indexOf('|');
        const indexOfEqual = nodeInputItem.indexOf('=');
        // we want to ensure that the colon and star only appear once. If they appear
        // more than once, then the index and lastIndex values would differ.
        if (indexOfColon === -1 ||
            indexOfColon !== lastIndexOfColon ||
            indexOfStar !== lastIndexOfStar) {
            hasFormattingErrors = true;
            accept('error', `The node input item is not formatted correctly. ':' and '*' can only appear once in each item.`, {
                node: nodeInputsField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.NODE_INPUT,
                },
            });
        }
        if (indexOfTilde !== -1 || indexOfPipe !== -1 || indexOfEqual !== -1) {
            hasFormattingErrors = true;
            accept('error', `The node input item is not formatted correctly. Characters '~', '|' and '=' are not allowed.`, {
                node: nodeInputsField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.NODE_INPUT,
                },
            });
        }
        if (!hasFormattingErrors) {
            // Split the string into it's parts
            const inputVariable = nodeInputItem.slice(0, indexOfColon).trim();
            const nodeNumber = indexOfStar !== -1
                ? nodeInputItem.slice(indexOfColon + 1, indexOfStar).trim()
                : nodeInputItem.slice(indexOfColon + 1).trim();
            const payloadVariable = indexOfStar !== -1 ? nodeInputItem.slice(indexOfStar + 1).trim() : '';
            // The inputVariable should not have appeared in a previous node input item
            if (!inputVariable || inputVariableMap[inputVariable]) {
                accept('error', `Variable name '${inputVariable}' appears in more than one items.`, {
                    node: nodeInputsField,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: node?.name,
                        propertyName: FRONTEND_PROPERTY_NAME.NODE_INPUT,
                    },
                });
            }
            if (inputVariable) {
                inputVariableMap[inputVariable] = true;
            }
            // If * is specified, then the payload variable should not be empty
            if (indexOfStar !== -1 && !payloadVariable) {
                accept('error', `The node input item is not formatted correctly. Payload variable cannot be empty.`, {
                    node: nodeInputsField,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: node?.name,
                        propertyName: FRONTEND_PROPERTY_NAME.NODE_INPUT,
                    },
                });
            }
            // The referenced node must exist
            const refNodeFields = pifFileSummary.getNodeByNodeNumber(nodeNumber);
            if (!refNodeFields) {
                accept('error', `Could not resolve reference to Node named '${nodeNumber}'.`, {
                    node: nodeInputsField,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: node?.name,
                        propertyName: FRONTEND_PROPERTY_NAME.NODE_INPUT,
                    },
                });
            }
            else {
                // The referenced node exists. Get the required fields for the referenced node.
                const { nodeTypeField: refNodeTypeField, outputField: refOutputField } = refNodeFields;
                if (payloadVariable) {
                    // If payload variable exists, then the referenced node must be an action
                    // node, and the payload variable must be present in
                    if (refNodeTypeField?.nodeType?.value !== 'A') {
                        accept('error', `The referenced node '${refNodeFields.nodeNumber}' is not an action node.`, {
                            node: nodeInputsField,
                            data: {
                                id: idField?.id?.value,
                                nodeNumber: node?.name,
                                propertyName: FRONTEND_PROPERTY_NAME.NODE_INPUT,
                            },
                        });
                    }
                    else {
                        // Ensure that the variableName exists on the referenced node
                        const matchingOutputVariable = refOutputField?.output?.find((o) => {
                            return o.value === payloadVariable;
                        });
                        if (!matchingOutputVariable) {
                            accept('error', `The referenced variable '${payloadVariable}' does not exist on the referenced node '${refNodeFields.nodeNumber}'.`, {
                                node: nodeInputsField,
                                data: {
                                    id: idField?.id?.value,
                                    nodeNumber: node?.name,
                                    propertyName: FRONTEND_PROPERTY_NAME.NODE_INPUT,
                                },
                            });
                        }
                    }
                }
            }
        }
    });
}
//# sourceMappingURL=validate-node-inputs.js.map